import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["disabled", "title", "onClick"]
const _hoisted_3 = { key: 0 }

import { nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TimelineContextMenu',
  props: {
    position: {},
    title: {},
    items: {}
  },
  emits: ["select", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const menu = ref<HTMLElement>();
const position = ref({ left: "0px", top: "0px" });
let disposed = false;

async function place() {
  await nextTick();
  if (disposed || !menu.value) return;
  position.value = {
    left: `${Math.max(8, Math.min(props.position.x, window.innerWidth - menu.value.offsetWidth - 8))}px`,
    top: `${Math.max(8, Math.min(props.position.y, window.innerHeight - menu.value.offsetHeight - 8))}px`,
  };
  (menu.value.querySelector<HTMLButtonElement>("button:not(:disabled)") ?? menu.value).focus({ preventScroll: true });
}

function outside(event: PointerEvent) {
  if (!event.composedPath().includes(menu.value!)) emit("close");
}

function scroll(event: Event) {
  if (!menu.value?.contains(event.target as Node)) emit("close");
}

function close() {
  emit("close");
}

function keydown(event: KeyboardEvent) {
  if (event.key === "Tab") {
    emit("close");
    return;
  }
  if (event.key === "Escape") {
    event.preventDefault();
    event.stopPropagation();
    emit("close", true);
    return;
  }
  if (!["ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)) return;
  event.preventDefault();
  event.stopPropagation();
  const buttons = Array.from(menu.value?.querySelectorAll<HTMLButtonElement>("button:not(:disabled)") ?? []);
  if (!buttons.length) return;
  const current = buttons.indexOf(document.activeElement as HTMLButtonElement);
  const next = event.key === "Home" ? 0 : event.key === "End" ? buttons.length - 1
    : (current + (event.key === "ArrowDown" ? 1 : -1) + buttons.length) % buttons.length;
  buttons[next].focus();
}

watch(() => props.position, place);
onMounted(() => {
  void place();
  window.addEventListener("pointerdown", outside, true);
  window.addEventListener("scroll", scroll, true);
  window.addEventListener("resize", close);
  window.addEventListener("blur", close);
});
onBeforeUnmount(() => {
  disposed = true;
  window.removeEventListener("pointerdown", outside, true);
  window.removeEventListener("scroll", scroll, true);
  window.removeEventListener("resize", close);
  window.removeEventListener("blur", close);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      ref_key: "menu",
      ref: menu,
      class: "timeline-context-menu dsfg-typography",
      "data-clip-editor": "",
      role: "menu",
      tabindex: "-1",
      "aria-label": __props.title,
      style: _normalizeStyle(position.value),
      onContextmenu: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent","stop"])),
      onPointerdown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
      onKeydown: keydown
    }, [
      _createElementVNode("p", null, _toDisplayString(__props.title), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createElementBlock("button", {
          key: item.id,
          type: "button",
          role: "menuitem",
          disabled: item.disabled,
          title: item.hint,
          class: _normalizeClass({ danger: item.danger }),
          onClick: ($event: any) => (emit('select', item.id))
        }, _toDisplayString(item.label), 11, _hoisted_2))
      }), 128)),
      (__props.items.some(item => item.disabled && item.hint))
        ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(__props.items.find(item => item.disabled && item.hint)?.hint), 1))
        : _createCommentVNode("", true)
    ], 44, _hoisted_1)
  ]))
}
}

})